// extracted by mini-css-extract-plugin
export var chip = "_5p-0";
export var filterDropdown = "_5p-5";
export var filterItem = "_5p-6";
export var icon = "_5p-1";
export var removeButton = "_5p-3";
export var removeIcon = "_5p-4";
export var separator = "_5p-2";